import { createStreamHook } from '@/service/ws/use-web-socket-with-proto'
import { DbNewsPost, DbNewsStream } from '@/types/generated/public_api'

export const useDbNewsStream = createStreamHook<DbNewsStream, DbNewsPost>({
  channelKey: 'dbNewsStream',
  extractResponse: (message) => message.data?.dbNewsPost,
  getPayloadDeps: () => [],
  listenerChannelKey: 'dbNewsStream',
})
